
export const useIsNewReport = ( date:Date=new Date() ) => {

  return new Date(date).getTime() > new Date(process.env.REACT_APP_NEW_REPORT as string).getTime()
}


